import React, { useMemo, useRef } from "react";
import "../../../Assets/Css/Project.scss";
import Table from "../../../Components/Table";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { customStyle } from '../../../Components/Style'
import { useState } from "react";
import { connect } from "react-redux";
import Select from 'react-select'
import { toast, ToastContainer } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import CustomCalendar from '../../../Components/CustomCalendar';
import { getprojects } from "../../../Services/Project/action";
import moment from "moment";
import { deleteRecord } from "../../../Services/Delete/action";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../../Lib/RoleWiseFeatureWrapper";
import ModulesList from "../../../Assets/ModulesLiist";
import FeaturesList from "../../../Assets/FeaturesList";
import { exportData } from "../../../Lib/exportData";


const Project = (props) => {
    const location = useLocation();
    const [checked, setChecked] = useState(false);
    const [selectedId, setSelectedId] = useState([]);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const fileInputRef = useRef(null);
    const modalRef = useRef(null);
    const { employeeId } = useParams();

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Project,
        Featur_Name: FeaturesList.Update,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Project,
        Featur_Name: FeaturesList.Delete,
    });

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Project,
        Featur_Name: FeaturesList.View,
    });

    const navigate = useNavigate();

    const header = [
        { field: "checkbox" },
        { field: "ID" },
        { field: "Code" },
        { field: "Project" },
        { field: "Client" },
        { field: "Progress" },
        { field: "Status" },
        { field: "Action" },
    ];

    const ProjectStatus = [
        { value: "All", label: "All" },
        { value: "In Progress", label: "In Progress" },
        { value: "Not Started", label: "Not Started" },
        { value: "On Hold", label: "On Hold" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "Finished", label: "Finished" },
    ];

    const ProjectProgress = [
        { value: "0% - 20%", label: "0% - 20%" },
        { value: "21% - 40%", label: "21% - 40%" },
        { value: "41% - 60%", label: "41% - 60%" },
        { value: "61% - 80%", label: "61% - 80%" },
        { value: "81% - 99%", label: "81% - 99%" },
        { value: "100%", label: "100%" },
    ];

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        setIsLoading(true)
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const fetchData = async () => {
        try {
            await props.getprojects();
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };

    const showToastMessage = (error) => {
        toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
        });
    };

    useEffect(() => {
        if (props?.project) {
            const filteredProjects = props.project.filter(project =>
                project?.projectUserMap?.some(
                    item => item?.userProjectMap?.id === parseInt(employeeId, 10)
                )
            );

            setInData(
                filteredProjects.map((project) => ({
                    checkbox: {
                        value: project?.id,
                        type: "checkbox",
                    },
                    ID: {
                        value: `#${project?.id}`,
                        type: "text",
                    },
                    Code: {
                        value: project?.code || "CD_14-726",
                        type: "text",
                    },
                    Project: {
                        value: project?.name,
                        type: "text",
                    },
                    Status: {
                        value: project?.status,
                        type: 'status_type'
                    },
                    Client: {
                        value: project?.client?.name,
                        type: "text",
                    },
                    Progress: {
                        value: project?.completion_status || 0,
                        type: "progressbar",
                    },
                    Action: {
                        value: `/employees/view/${employeeId}/project/edit`,
                        value2: `/employees/view/${employeeId}/project/view/${project?.id}/overview`,
                        type: "action",
                    },
                    allData: {
                        ...project
                    },
                    "Start Date": {
                        value: project?.start_date
                    },
                    "End Date": {
                        value: project?.end_date
                    }
                }))
            );
        } else {
            setInData([]);
        }
    }, [props?.project]);


    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
                setFileName('');
                setSelectedFile(null);
                fileInputRef.current.value = null;
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    const handleFileChange = (event) => {
        const f = event.target.files[0];
        setSelectedFile(f);
        if (f) {
            setFileName(f.name);
        } else {
            setFileName('');
        }
    }

    const handleImportClick = async (event) => {
        try {
            setLoading(true);

            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const csvData = e.target.result;
                    await props.importPurchaseInvoiceCSV(selectedFile, csvData);
                    setLoading(false);
                    setFileName('');
                    setSelectedFile(null);
                    fileInputRef.current.value = null;
                } catch (error) {
                    setHasError(true);
                    console.error('Error importing purchse invoices:', error);
                    toast.error('Error importing purchse invoices:', error.message);
                    setLoading(false)

                }
            };

            reader.readAsText(selectedFile);

        } catch (error) {
            setHasError(true);
            console.error('Error importing transactions:', error);
            toast.error('Error importing transactions:', error.message);
            setLoading(false)
        }
    };

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            setExportLoading(true);
            handleXlsxDownload(ids);
            toast.success("Exported Successfully");
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    const handleXlsxDownload = (Ids) => {
        const excludedFields = ['checkbox', 'Action'];
        const columns = header
            .filter(col => !excludedFields.includes(col.field))
            .map(col => ({
                label: col.field,
                key: col.field
            }));

        const selectedData = inData
            .filter(item => Ids.includes(item.allData?.id))
            .map(row => {
                const newRow = {};

                columns.forEach(({ label, key }) => {
                    const cell = row[key];

                    if (!cell) {
                        newRow[label] = '';
                    } else if (Array.isArray(cell.value)) {
                        newRow[label] = cell.value.join(', ');
                    } else {
                        newRow[label] = cell.value ?? '';
                    }
                });

                return newRow;
            });

        exportData({
            data: selectedData,
            columns,
            fileName: 'Employee_Project_Report',
            format: 'xlsx',
        });
        setExportLoading(false)
        setTotalSelectedIds([])
    };

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const handleAddClick = () => {
        navigate(`/employees/view/${employeeId}/project/add`);
    }

    const initialState = {
        projectstatus: null,
        date: "",
        projectprogress: null
    }

    const [clientData, setClientData] = useState(initialState);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);

    const applyFilters = ({ status, startDate, endDate, progress }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((task) => {
            let matchesStatus = true;
            let matchesProgress = true;
            let matchesDate = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(task?.["Start Date"]?.value).startOf('day');
                const itemDueDate = task?.["Due Date"]?.value
                    ? moment(task?.["Due Date"]?.value).startOf('day')
                    : itemStartDate;

                const filterStart = moment(filteredStartDate || startDate).startOf('day');
                const filterEnd = moment(filteredEndDate || endDate).endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
            }

            if (status && status?.value !== "All") {
                matchesStatus = task?.Status?.value?.toLowerCase() == status?.value?.toLowerCase();
            }

            if (progress) {
                const progressValues = progress?.value?.split('-');
                const p1 = progressValues[0]?.trim()?.split("%")[0]?.trim();
                const p2 = progressValues[1]?.trim()?.split("%")[0]?.trim();
                matchesProgress = p1 <= task?.Progress?.value && task?.Progress?.value <= p2;
            }
            return matchesStatus && matchesProgress && matchesDate;
        });
        setFilteredData(filtered);
    };


    const handleSelectStatusChange = (val) => {
        setClientData((prevVal) => ({
            ...prevVal,
            projectstatus: val,
        }));
        applyFilters({ status: val, startDate: filteredStartDate, endDate: filteredEndDate, progress: clientData?.projectprogress });
    };

    const handleClear = () => {
        setClientData({
            projectstatus: "",
            date: '',
            projectprogress: ''
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }

    return (
        <div className="project-main">
            <div className="row">
                <div className="col-lg-4">
                    <div className="input-group">
                        <Select
                            options={ProjectStatus}
                            styles={{
                                ...customStyle,
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 2,
                                }),
                            }}
                            value={clientData.projectstatus}
                            placeholder="All"
                            onChange={(val) => {
                                handleSelectStatusChange(val)
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                        />
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="input-group">
                        <CustomCalendar
                            inData={inData}
                            setFilteredData={setFilteredData}
                            applyFilters={(params) => { applyFilters(params) }}
                            startDate={filteredStartDate}
                            endDate={filteredEndDate}
                            setStartDate={setFilteredStartDate}
                            setEndDate={setFilteredEndDate} />
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="input-group">
                        <Select
                            options={ProjectProgress}
                            styles={{
                                ...customStyle,
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 2,
                                }),
                            }}
                            value={clientData.projectprogress}
                            placeholder="Progress"
                            onChange={(val) => {
                                setClientData((preVal) => ({
                                    ...preVal,
                                    projectprogress: val
                                }));

                                applyFilters({ status: clientData?.projectstatus, startDate: filteredStartDate, endDate: filteredEndDate, progress: val })
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                        />
                    </div>
                </div>
            </div>

            <div className="gap-4 addproject-export-btn">
                <RoleWiseFeatureWrapper
                    modules={props?.modules}
                    features={props?.features}
                    user={props?.user}
                    ModuleName={ModulesList.Project}
                    Featur_Name={FeaturesList.Create}>
                    <button className="custom-project-btn" disabled={props.loading} onClick={handleAddClick}>
                        {props.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Add Project"}
                    </button>
                </RoleWiseFeatureWrapper>

                <button
                    className="export-btn"
                    id="exportBtn"
                    disabled={!checked || exportLoading}
                    onClick={(e) => {
                        e.preventDefault();
                        handleClick(totalSelectedIds);
                    }}
                >
                    {exportLoading ? (
                        <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                        />
                    ) : (
                        "Export"
                    )}
                </button>

                {(clientData?.projectstatus || filteredData?.length > 0 || dateStatus || clientData?.projectprogress) && (

                    <button
                        className="export-btn"
                        disabled={props.loading}
                        onClick={handleClear}
                    >
                        {props.loading ? (
                            <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                        ) : (
                            'Clear'
                        )}
                    </button>
                )}
            </div>

            <div className="invoice-table-part">
                <Table
                    header={header}
                    data={(clientData?.projectstatus || dateStatus || clientData?.projectprogress) ? filteredData : inData}
                    footer={footer}
                    count={count}
                    checked={checked}
                    records={count}
                    totalSelectedIds={totalSelectedIds}
                    defaultParams={params}
                    selectedId={selectedId}
                    handleChange={handleChange}
                    loading={props.loading}
                    showIsEdit={canEdit}
                    showIsDelete={canDelete}
                    showIsView={canView}
                    deleteRecord={props?.deleteRecord}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.projectReducer.loading,
        project: state.projectReducer.project,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getprojects: () => {
            dispatch(getprojects());
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue));
            await dispatch(getprojects());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Project);
